import { IComponentOptions } from "angular";
import { MealLogEntryDetailController } from "./controller";

export const vsComponentName = "mealLogEntryDetail";

export const mealLogEntryDetailComponentOptions: IComponentOptions = {
  controller: MealLogEntryDetailController,
  controllerAs: "detailController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    mealLog: "<",
    info: "<",
    afterDelete: "&",
  },
};
